import type {
  HeaderApiResponse,
  HeaderData,
  HeaderMenuItem,
  HeaderMenuSection,
} from '@/shared/types/header';

const transformHeaderData = (apiData: HeaderApiResponse): HeaderData => {
  const {
    healthcare = [],
    wellness = [],
    accomodation = [],
  } = apiData.data || {};

  const menus: HeaderMenuSection[] = [];

  const aboutMenu: HeaderMenuSection = {
    menu: 'About Us',
    route: '/about',
    sub: [
      { title: 'The Sanur', route: '/about' },
      { title: 'Sustainability', route: '/sustainability' },
    ],
  };
  menus.push(aboutMenu);

  if (healthcare && healthcare.length > 0) {
    const healthcareMenu: HeaderMenuSection = {
      menu: 'Healthcare',
      route: '/healthcare',
      sub: [
        ...healthcare.map(
          (item): HeaderMenuItem => ({
            title: item.name,
            route: `/healthcare/international/${item.slug}`,
          })
        ),
        {
          title: 'Clinics',
          route: '/healthcare/coe',
        },
      ],
    };
    menus.push(healthcareMenu);
  }

  if (wellness && wellness.length > 0) {
    const wellnessMenu: HeaderMenuSection = {
      menu: 'Holistic Wellness',
      route: '/wellness',
      sub: wellness.map(
        (item): HeaderMenuItem => ({
          title: item.name,
          route: `/wellness/${item.slug}`,
        })
      ),
    };
    menus.push(wellnessMenu);
  }

  if (accomodation && accomodation.length > 0) {
    const accommodationMenu: HeaderMenuSection = {
      menu: 'Accommodations',
      route: '/accomodation',
      sub: accomodation.map(
        (item): HeaderMenuItem => ({
          title: item.name,
          route: `/accomodation/${item.slug}`,
        })
      ),
    };
    menus.push(accommodationMenu);
  }

  const facilitiesMenu: HeaderMenuSection = {
    menu: 'Facilities',
    route: '/venue',
    sub: [
      {
        title: 'Bali Beach Convention',
        route: '/venue/bali-beach-convention-center',
      },
      { title: 'Meeting Rooms', route: '/venue/meeting-rooms' },
      { title: 'Dining', route: '/venue/dining' },
      { title: 'Shop', route: '/venue/shop' },
    ],
  };
  menus.push(facilitiesMenu);

  return { menus };
};

export const getHeaderData = async (): Promise<HeaderData> => {
  const baseURL =
    import.meta.env.VITE_BASE_API_URL || 'http://34.101.225.127:8080';
  const response = await fetch(`${baseURL}/sanur-api/v1/header`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const apiResponse: HeaderApiResponse = await response.json();
  return transformHeaderData(apiResponse);
};
